import React from "react";
import { Card } from "@/components/ui/card";
import { formatINR } from "@/lib/api";
import { ShoppingBag, IndianRupee, Wallet, AlertTriangle, Clock, TrendingUp } from "lucide-react";

const CARDS = [
  { key: "todays_orders", label: "Today's Orders", icon: ShoppingBag, money: false, tone: "text-[#1E3E5C]" },
  { key: "todays_sales", label: "Today's Sales", icon: TrendingUp, money: true, tone: "text-[#1F5B2E]" },
  { key: "todays_payments", label: "Today's Payments", icon: IndianRupee, money: true, tone: "text-[#1F5B2E]" },
  { key: "total_outstanding", label: "Total Outstanding", icon: Wallet, money: true, tone: "text-[#7A4B12]" },
  { key: "overdue_amount", label: "Overdue Amount", icon: AlertTriangle, money: true, tone: "text-[#7A1F1F]" },
  { key: "pending_approval", label: "Pending Approval", icon: Clock, money: false, tone: "text-[#7A4B12]" },
];

export const OrdersSummaryCards = ({ data }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-5" data-testid="orders-summary-cards">
      {CARDS.map(({ key, label, icon: Icon, money, tone }) => (
        <Card key={key} className="p-3.5" data-testid={`summary-card-${key}`}>
          <div className="flex items-center justify-between mb-1.5">
            <span className="text-xs text-muted-foreground">{label}</span>
            <Icon className="h-3.5 w-3.5 text-muted-foreground" />
          </div>
          <div className={`font-mono text-lg font-medium ${tone}`}>
            {!data ? "…" : money ? formatINR(data[key] || 0) : (data[key] || 0)}
          </div>
        </Card>
      ))}
    </div>
  );
};
